import colors from "core/resources/theme/colors";

import { ListItem, ListItemCol, ListItemInner } from "./styles";
import { useRef } from "react";
import { useEffect } from "react";
import { Input } from "@chakra-ui/input";
import Button from "ui/components/Button";
import { showError } from "infra/helpers/alerta";
import { SortableDragHandle } from "components/SortableDragHandle";

function OpcaoItem({
  value,
  index,
  onChangePergunta,
  onRemovePergunta,
  handleAddOpcao,
}: any) {
  const inputRef = useRef<any>();

  useEffect(() => {
    if (value.editando && inputRef.current) {
      setTimeout(() => {
        inputRef.current?.focus();
      }, 300);
    }
  }, [value.editando, inputRef]);

  return (
    <ListItem style={{ zIndex: 999999 }}>
      <ListItemCol
        style={{
          color: colors.black500,
          paddingLeft: 0,
          paddingRight: 0,
          width: 20,
        }}
      >
        {index + 1}º
      </ListItemCol>

      <ListItemCol
        style={{
          backgroundColor: colors.black700,
          color: "white",
          paddingLeft: 3,
          paddingRight: 3,
          right: -17,
          position: "relative",
          zIndex: 1,
          borderTopLeftRadius: 5,
          borderBottomLeftRadius: 5,
          cursor: "move",
        }}
      >
        <SortableDragHandle />
      </ListItemCol>

      <ListItemInner>
        {value.editando ? (
          <Input
            // ref={inputRef}
            value={value.titulo}
            onKeyDown={(ev) => {
              if (ev.keyCode === 13) {
                ev.preventDefault();
                if (value.titulo) {
                  onChangePergunta(index, "editando", !value.editando);
                  handleAddOpcao();
                }
              }
            }}
            onChange={(ev) => {
              onChangePergunta(index, "titulo", ev.target.value);
            }}
          />
        ) : (
          <div
            style={{
              paddingTop: 0,
              fontWeight: "bold",
              color: colors.black700,
            }}
          >
            {" "}
            {value.titulo}{" "}
          </div>
        )}
      </ListItemInner>

      <ListItemCol
        style={{
          marginLeft: 8,
          marginRight: 8,
          cursor: "pointer",
        }}
      >
        <Button
          colorScheme={value.editando ? "green" : undefined}
          onClick={() => {
            if (!value.titulo && value.editando) {
              showError("Informe o titulo da opção");
            } else {
              onChangePergunta(index, "editando", !value.editando);
            }
          }}
        >
          <i
            className={`mdi mdi-${value.editando ? "check" : "pencil"}`}
            style={{
              fontSize: 18,
              color: value.editando ? colors.white : colors.black700,
            }}
          />
        </Button>
      </ListItemCol>

      <ListItemCol
        style={{
          marginLeft: 8,
          marginRight: 8,
          cursor: "pointer",
        }}
      >
        <Button onClick={onRemovePergunta}>
          <i
            className="mdi mdi-delete-outline"
            style={{ fontSize: 20, color: colors.black700 }}
          />
        </Button>
      </ListItemCol>
    </ListItem>
  );
}

export default OpcaoItem;
